<template>
  <div ref="wrapper" class="content-wrapper">
    <v-card tile class="pa-2 ma-0 elevation-0">
      <v-card-text
        v-for="layer in runtimeLayers"
        :key="layer.id"
        class="pa-2 ma-0 mb-3 category"
      >
        <p class="ma-0 subtitle-1">
          <b>{{ layer.title }}</b>
        </p>
        <v-container class="pa-0 ma-0" fluid>
          <v-row class="pa-0 ma-0">
            <v-col class="pa-0 pr-1 mx-0" :sm="layer.type === 'multiBuild' ? 6 : 12">
              <v-select
                v-model="layer.selectedBuild"
                :items="layer.builds[layer.selectedPlatform]"
                label="Build"
                background-color="grey lighten-1"
                clearable
                hide-details
                dense
                solo
                flat
                item-text="build_id"
                item-value="build_id"
                @change="(e) => {
                  layer.show = false
                  if (layer.activeCategories) {
                    layer.activeCategories = []
                  }
                  toggleRuntime(layer)
                }"
              >
                <template v-slot:item="{ item }">
                  <template>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ item.build_id }}
                        </span>
                      </template>
                      <span>{{ item.build_text }}</span>
                    </v-tooltip>
                  </template>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="layer.type === 'multiBuild'" class="pa-0 pl-1 ma-0" sm="6">
              <v-select
                v-model="layer.selectedPrevBuild"
                :items="layer.prevBuilds[layer.selectedPrevPlatform]"
                label="P. Build"
                background-color="grey lighten-1"
                clearable
                hide-details
                dense
                solo
                flat
                item-text="build_id"
                item-value="build_id"
                @change="(e) => {
                  layer.show = false
                  if (layer.activeCategories) {
                    layer.activeCategories = []
                  }
                  toggleRuntime(layer)
                }"
              >
                <template v-slot:item="{ item }">
                  <template>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ item.build_id }}
                        </span>
                      </template>
                      <span>{{ item.build_text }}</span>
                    </v-tooltip>
                  </template>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row class="pa-0 pt-1 ma-0">
            <v-col class="pa-0 pr-1 mx-0" cols="12" :sm="layer.type === 'multiBuild' ? 6 : 12">
              <v-select
                v-model="layer.selectedPlatform"
                :items="platforms"
                label="Platform"
                background-color="grey lighten-2"
                hide-details
                dense
                solo
                flat
                @change="(e) => {
                  layer.selectedBuild = null
                  layer.show = false
                  if (layer.activeCategories) {
                    layer.activeCategories = []
                  }
                  toggleRuntime(layer)
                }"
              />
            </v-col>
            <v-col v-if="layer.type === 'multiBuild'" class="pa-0 pl-1 ma-0" cols="12" sm="6">
              <v-select
                v-model="layer.selectedPrevPlatform"
                :items="platforms"
                label="P. Platform"
                background-color="grey lighten-2"
                hide-details
                dense
                solo
                flat
                @change="(e) => {
                  layer.selectedPrevBuild = null
                  layer.show = false
                  if (layer.activeCategories) {
                    layer.activeCategories = []
                  }
                  toggleRuntime(layer)
                }"
              />
            </v-col>
          </v-row>
          <v-row class="pa-0 pt-1 ma-0">
            <v-col class="pa-0 mx-0" cols="12">
              <v-select
                v-model="layer.segmentNumber"
                :items="segments"
                label="Segment number"
                hide-details
                filled
                dense
                @change="(e) => {
                  if (layer.show) {
                    toggleRuntime(layer)
                  }
                }"
              />
            </v-col>
          </v-row>
          <v-row class="pa-0 pt-1 ma-0">
            <template v-if="'layerСategories' in layer === true">
              <v-col
                v-if="'radioGroup' in layer === true"
                class="pa-0 ma-0"
                cols="12"
              >
                <v-radio-group
                  v-model="layer.radio"
                  hide-details
                  class="pa-0 ma-0"
                  @change="(e) => {
                    if (layer.show) {
                      toggleLayerWithMulticategories(layer)
                    }
                  }"
                >
                  <v-radio
                    v-for="radio in layer.radioGroup"
                    :key="radio.value"
                    :label="radio.label"
                    :value="radio.value"
                    class="mb-0"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                v-for="layerСategory in layer.layerСategories[layer.selectedPlatform]"
                :key="(typeof layerСategory === 'object' ? layerСategory.table_name : layerСategory ) + '-' + layer.selectedPlatform"
                class="pa-0 ma-0"
                cols="12"
              >
                <v-sheet
                  :class="{
                    'grey lighten-3': ('radioGroup' in layerСategory === true ),
                    'white':  ('radioGroup' in layerСategory !== true ),
                  }"
                  v-if="typeof layerСategory === 'object'"
                >
                  <v-checkbox
                    v-model="layer.activeCategories"
                    :label="layerСategory.alias"
                    :value="layerСategory.table_name"
                    hide-details
                    class="mt-0"
                    @change="(e) => {
                      layer.show = layer.activeCategories.length > 0;
                      if ('activeRadio' in layer === true) {
                        if (layer.show) {
                          layer.layerСategories[layer.selectedPlatform].forEach(category => {
                            if (category.radio) {
                              layer.activeRadio.push(category.radio)
                            }
                          })
                        } else {
                          layer.activeRadio = layer.activeRadio.filter(radio => radio !== layerСategory.radio);
                        }
                      }
                      toggleLayerWithMulticategories(layer);
                    }"
                  />
                  <v-radio-group
                    v-model="layerСategory.radio"
                    hide-details
                    class="pl-4 pb-1 ma-0"
                    @change="(e) => {
                      if (layer.show) {
                        layer.activeRadio = layer.activeRadio.filter(radio =>
                          !layerСategory.radioGroup.some(r => r.value === radio)
                        );
                        layer.activeRadio.push(e);
                        toggleLayerWithMulticategories(layer)
                      }
                    }"
                  >
                    <v-radio
                      v-for="radio in layerСategory.radioGroup"
                      :key="radio.value"
                      :label="radio.label"
                      :value="radio.value"
                      class="mb-0"
                    />
                  </v-radio-group>
                </v-sheet>
                <v-checkbox
                  v-else
                  v-model="layer.activeCategories"
                  :label="'show ' + layerСategory"
                  :value="layerСategory"
                  hide-details
                  class="mt-0"
                  @change="(e) => {
                    layer.show = layer.activeCategories.length > 0
                    toggleLayerWithMulticategories(layer)
                  }"
                />
              </v-col>
            </template>
            <v-col v-else class="pa-0 ma-0" cols="12">
              <v-radio-group
                v-if="'radioGroup' in layer === true"
                v-model="layer.radio"
                hide-details
                class="pa-0 ma-0"
                @change="(e) => {
                  if (layer.show) {
                    toggleLayer(layer)
                  }
                }"
              >
                <v-radio
                  v-for="radio in layer.radioGroup"
                  :key="radio.value"
                  :label="radio.label"
                  :value="radio.value"
                  class="mb-0"
                />
              </v-radio-group>
              <v-checkbox
                v-model="layer.show"
                label="show layer"
                hide-details
                class="mt-0"
                @change="toggleLayer(layer)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import L from 'leaflet';
import { llmOnClick, discUtilizationOnClick, levelLoadsOnClick } from '../../plugins/click-layers-functions/index'
import { MapOptimizationLegend, LLMLegend, LevelLoadsLegend } from '../../plugins/leaflet-legends/index'
export default {
  props: {
    map: {
      default() { return null }
    }
  },
  data() {
    return {
      checkbox: false,
      cardMaxHeight: '100%',
      segments: [1],
      runtimeLayers: []
    }
  },
  async mounted () {
    await Promise.all([
      this.loadCategories(),
      this.getSegments()
    ])
    this.map.on('change-map-id', this.changeMapId)
    this.map.on('change-map', this.changeMap)
    this.map.on('change-type', this.filterLayers)
  },
  beforeDestroy () {
    this.map.off('change-map-id', this.changeMapId)
    this.map.off('change-map', this.changeMap)
    this.map.off('change-type', this.filterLayers)
  },
  computed: {
    platforms() {
      return this.$store.state.platforms.map(pl => pl.name);
    },
    clickLayersFunctions() {
      return {
        'custom': () => {},
        'map_optimization': () => {},
        'llm': llmOnClick.bind(this),
        'llmpoints': llmOnClick.bind(this),
        'discutilization': discUtilizationOnClick.bind(this),
        'fpspoints': () => {},
        'll_index_-1': levelLoadsOnClick.bind(this),
        'll_index_0': levelLoadsOnClick.bind(this),
        'runner': () => {}
      }
    },
    addGlobalLegend() {
      return {
        'custom': null,
        'map_optimization': MapOptimizationLegend,
        'llm': LLMLegend,
        'llmpoints': LLMLegend,
        'discutilization': null,
        'fpspoints': null,
        'll_index_-1': LevelLoadsLegend,
        'll_index_0': LevelLoadsLegend,
        'runner': null
      }
    }
  },
  methods: {
    async loadCategories () {
      this.runtimeLayers.forEach(category => {
        const currenGeoJSON = this.map.getLayerById(category.category)
        if (currenGeoJSON) {
          this.map.removeLayer(currenGeoJSON)
        }
      })

      const [runtimeConfig, runtimeCategories] = await Promise.all([
        this.$axios.get(this.$store.getters.projectPath + '/configs/runtime'),
        this.$axios.get(this.$store.getters.projectPath + '/runtime-categories/map')
      ])

      this.runtimeConfig = runtimeConfig.data
      this.runtimeLayers = await Promise.all(runtimeCategories.data.map(async (layer) => {
        let show = false
        let segmentNumber = 1
        let selectedBuild = null
        let selectedPrevBuild = undefined
        let selectedPlatform = this.$store.getters.defaultPlatform
        let selectedPrevPlatform = undefined

        if (this.$route.query[layer.category + '_platform']) {
          selectedPlatform = this.$route.query[layer.category + '_platform']
        }

        if (this.$route.query[layer.category + '_prevPlatform']) {
          selectedPrevPlatform = this.$route.query[layer.category + '_prevPlatform']
        } else if (layer.type === 'multiBuild') {
          selectedPrevPlatform = this.$store.getters.defaultPlatform
        }

        if (this.$route.query[layer.category + '_build']) {
          selectedBuild = this.$route.query[layer.category + '_build']
        }

        if (this.$route.query[layer.category + '_prevBuild']) {
          selectedPrevBuild = this.$route.query[layer.category + '_prevBuild']
        } else if (layer.type === 'multiBuild') {
          selectedPrevBuild = null
        }

        if (this.$route.query[layer.category + '_segment']) {
          segmentNumber = parseInt(this.$route.query[layer.category + '_segment']) || 1
        }

        if (this.$route.query.activeCategories) {
          if (Array.isArray(this.$route.query.activeCategories)) {
            show = this.$route.query.activeCategories.includes(layer.category)
          } else {
            show = this.$route.query.activeCategories === layer.category
          }
        }

        let { data } = await this.$axios.get(
          `${this.$store.getters.projectPath}${layer.url}/info/${this.map.options.currentMapId}`
        )

        const layerData = {
          ...layer,
          ...{
            show,
            segmentNumber,
            selectedBuild,
            selectedPrevBuild,
            selectedPlatform,
            selectedPrevPlatform,
            builds: 'layerСategories' in layer === true ? data.builds : data,
            prevBuilds: 'layerСategories' in layer === true ? data.builds : data,
          }
        }

        if (show) {
          this.toggleLayer(layerData)
        }

        return layerData
      }))
    },
    toggleLayerWithMulticategories(layer) {
      let data = {};
      ({
        selectedBuild: data.selectedBuild,
        selectedPlatform: data.selectedPlatform,
        selectedPrevBuild: data.selectedPrevBuild,
        selectedPrevPlatform: data.selectedPrevPlatform,
        segmentNumber: data.segmentNumber,
        show: data.show,
        title: data.title,
        layers: data.layers,
        url: data.url,
        category: data.category,
        radio: data.radio,
        activeCategories: data.activeCategories,
        activeRadio: data.activeRadio
      } = layer);
      this.toggleRuntime(data);
    },
    toggleLayer(layer) {
      let data = {};
      ({
        selectedBuild: data.selectedBuild,
        selectedPlatform: data.selectedPlatform,
        selectedPrevBuild: data.selectedPrevBuild,
        selectedPrevPlatform: data.selectedPrevPlatform,
        segmentNumber: data.segmentNumber,
        show: data.show,
        title: data.title,
        layers: data.layers,
        url: data.url,
        radio: data.radio,
        category: data.category
      } = layer);
      this.toggleRuntime(data);
    },
    getHeatMapColor(value, reverse = false) {
      const NUM_COLORS = 4;
      let red, green, blue, idx1, idx2, color, fractBetween = 0;
      color = [[76,175,79], [255,235,59], [255,152,15], [244,67,54]];
      color = reverse && color.reverse() || color;

      if (value <= 0) {
        idx1 = idx2 = 0;
      }
      else if(value >= 1) {
        idx1 = idx2 = NUM_COLORS-1;
      } else {
        value = value * (NUM_COLORS-1);
        idx1  = Math.floor(value);
        idx2  = idx1+1;
        fractBetween = value - idx1;
      }
      red   = (color[idx2][0] - color[idx1][0])*fractBetween + color[idx1][0];
      green = (color[idx2][1] - color[idx1][1])*fractBetween + color[idx1][1];
      blue  = (color[idx2][2] - color[idx1][2])*fractBetween + color[idx1][2];
      return 'rgb('+red+','+green+','+blue+')';
    },
    getColor (value, config) {
      let color = '#FFFFFF'
      config.forEach(platformConfig => {
        if (value >= platformConfig.min && value <= platformConfig.max) {
          color = platformConfig.color
        }
      })
      return color
    },
    hideTooltips(l) {
      let zoom = this.map.getZoom()
      if (zoom < 3) {
        if (l.getTooltip) {
          let toolTip = l.getTooltip()
          if (toolTip) {
            this.map.closeTooltip(toolTip)
          }
        }
      } else if (zoom >= 3) {
        if (l.getTooltip) {
          let toolTip = l.getTooltip()
          if (toolTip) {
            this.map.addLayer(toolTip)
          }
        }
      }
    },
    async toggleRuntime(layer) {
      const currenGeoJSON = this.map.getLayerById(layer.category)
      if (currenGeoJSON) {
        this.map.removeLayer(currenGeoJSON)
      }

      if (layer.show) {
        const activeCategories = layer.activeCategories && layer.activeCategories.length > 0
          ? layer.activeCategories : undefined
        // get runtime data
        let { data } = await this.$axios.get(
          `${this.$store.getters.projectPath}${layer.url}/${this.map.options.currentMapId}`,
          {
            params: {
              selectedBuild: layer.selectedBuild,
              selectedPrevBuild: layer.selectedPrevBuild,
              selectedPlatform: layer.selectedPlatform,
              selectedPrevPlatform: layer.selectedPrevPlatform,
              segmentNumber: layer.segmentNumber,
              activeRadio: layer.activeRadio,
              radio: layer.radio,
              activeCategories,
              mapName: this.map.options.currentMap,
            }
          }
        )

        let index = this.runtimeLayers.findIndex(lr => lr.category === layer.category)
        this.$set(this.runtimeLayers, index, Object.assign({}, this.runtimeLayers[index], {
          selectedBuild: data.selectedBuild,
          selectedPrevBuild: data.selectedPrevBuild
        }))

        if (layer.activeCategories && layer.activeCategories.length > 0) {
          const currenGeoJSON = this.map.getLayerById(layer.category);
          if (currenGeoJSON) {
            this.map.removeLayer(currenGeoJSON)
          }
        }

        // init geo json group
        let geoJSONlayers = L.geoJSON(data.geoJSON, {
          style: (feature) => this.style(layer, data)[feature.properties.category](feature),
          pointToLayer: (feature, latlng) => this.pointToLayer(layer, data)[feature.properties.category](feature, latlng),
          onEachFeature: this.onEachRuntimeFeature
        });

        // init custom parameters
        geoJSONlayers.id = layer.category;
        geoJSONlayers.data = {};
        ({
          count: geoJSONlayers.data.count,
          deltaValuePerCount: geoJSONlayers.data.deltaValuePerCount,
          maxValue: geoJSONlayers.data.maxValue,
          valuePerCount: geoJSONlayers.data.valuePerCount,
          totalObjectNum: geoJSONlayers.data.totalObjectNum,
          totalComponentNum: geoJSONlayers.data.totalComponentNum,
          totalUniqueMaterialsNum: geoJSONlayers.data.totalUniqueMaterialsNum,
          deltaTotalObjectNum: geoJSONlayers.data.deltaTotalObjectNum,
          deltaTotalComponentNum: geoJSONlayers.data.deltaTotalComponentNum,
          deltaUniqueMaterialsNum: geoJSONlayers.data.deltaUniqueMaterialsNum
        } =  data);

        ({
          selectedPlatform: geoJSONlayers.data.selectedPlatform,
          selectedPrevPlatform: geoJSONlayers.data.selectedPrevPlatform
        } = layer);

        // init events
        geoJSONlayers.on('add', (event) => {
          geoJSONlayers.eachLayer(layer => {
            if (layer.feature.properties.map_type == this.map.options.currentType) {
              this.map.addLayer(layer)
            } else {
              this.map.removeLayer(layer)
            }
          })

          if (this.addGlobalLegend[layer.category]) {
            const legend = new this.addGlobalLegend[layer.category]({
              _id: layer.category + '_global_legend',
              info: event.target
            })
            legend.addTo(this.map)
          }
        })

        geoJSONlayers.on('remove', (event) => {
          const layer = event.target
          const globalLegend = layer.control
          if (globalLegend) {
            this.map.removeControl(globalLegend)
          }
        })
        // add to map
        geoJSONlayers.addTo(this.map)

        const query = {}
        let queryActiveCategories = this.$route.query.activeCategories || []

        if (
          (Array.isArray(queryActiveCategories) &&  queryActiveCategories.includes(layer.category)) ||
          queryActiveCategories === layer.category
        ) {
          console.log(1)
          return
        }

        if (Array.isArray(queryActiveCategories)) {
          queryActiveCategories.push(layer.category)
        } else if (typeof queryActiveCategories === 'string') {
          queryActiveCategories = [queryActiveCategories, layer.category]
        }

        queryActiveCategories.forEach(val => {
          query[val + '_platform'] = this.$route.query[val + '_platform'] || layer.selectedPlatform
          query[val + '_prevPlatform'] = this.$route.query[val + '_prevPlatform'] || layer.selectedPrevPlatform
          query[val + '_build'] = this.$route.query[val + '_build'] || data.selectedBuild
          query[val + '_prevBuild'] = this.$route.query[val + '_prevBuild'] || data.selectedPrevBuild
          query[val + '_segment'] = this.$route.query[val + '_segment'] || layer.segmentNumber
        })

        this.updateRouterQuery({
          activeCategories: queryActiveCategories,
          ...query
        })
      } else {
        const query = {}
        let activeCategories = this.$route.query.activeCategories

        if (Array.isArray(activeCategories)) {
          activeCategories = activeCategories.filter(category => category !== layer.category)
          activeCategories.forEach(val => {
            query[val + '_platform'] = this.$route.query[val + '_platform']
            query[val + '_prevPlatform'] = this.$route.query[val + '_prevPlatform']
            query[val + '_build'] = this.$route.query[val + '_build']
            query[val + '_prevBuild'] = this.$route.query[val + '_prevBuild']
            query[val + '_segment'] = this.$route.query[val + '_segment']
          })
        } else if (activeCategories) {
          query[activeCategories + '_platform'] = this.$route.query[activeCategories + '_platform']
          query[activeCategories + '_prevPlatform'] = this.$route.query[activeCategories + '_prevPlatform']
          query[activeCategories + '_build'] = this.$route.query[activeCategories + '_build']
          query[activeCategories + '_prevBuild'] = this.$route.query[activeCategories + '_prevBuild']
          query[activeCategories + '_segment'] = this.$route.query[activeCategories + '_segment']

          if (activeCategories == layer.category) {
            activeCategories = undefined
          }
        }

        this.updateRouterQuery({
          activeCategories,
          ...query
        })
      }
    },
    style (layer, data) {
      return {
        'custom': (feature) => {
          switch (true) {
            case feature.properties.type === 'point':
              return {
                stroke: false,
                radius: 3,
                fillOpacity: 1,
                fillColor: feature.properties.color
              }
            case feature.properties.type === 'rectangle2':
              return {
                weight: 2,
                opacity: 0.8,
                color: feature.properties.color,
                fillOpacity: 0.3,
                fillColor: feature.properties.color,
              }
            case feature.properties.type === 'rectangle4':
              return {
                weight: 2,
                opacity: 0.6,
                color: feature.properties.color,
                fillOpacity: 0.2,
                fillColor: feature.properties.color,
              }
            case feature.properties.type === 'angles':
              return {
                color: feature.properties.color,
              }
            default: return undefined;
          }
        },
        'map_optimization': (feature) => ({
          color: feature.properties.stats[layer.radio][0] == data.maxValue[layer.radio]
            ? "#0000ff"
            : this.getColor(
                feature.properties.stats[layer.radio][0],
                this.runtimeConfig['map_optimization'][layer.selectedPlatform][layer.radio]
              )
          ,
          weight: 1
        }),
        'llm': (feature) => ({
          color: feature.properties.stats.Total[0] == data.maxValue
            ? "#0000ff"
            : feature.properties.stats.Total[0] > this.runtimeConfig['llm'][layer.selectedPlatform].total
              ? '#2196f3'
              : '#81c784',
          weight: 1
        }),
        'llmpoints': (feature) => {
          const color = this.getColor(
            feature.properties.stats.Total[0],
            this.runtimeConfig['llmpoints'][layer.selectedPlatform].total
          )
          return {
            color: color,
            fillColor: color,
            weight: 3,
            radius: 14
          }
        },
        'discutilization': (feature) => ({
          color: feature.properties.stats.maxAddedMemory == data.maxValue
            ? "#0000ff"
            : '#81c784',
          weight: 1
        }),
        'fpspoints': (feature) => {
          if (feature.geometry.type === 'Point') {
            return {
              color: 'white',
            }
          } else {
            return {
              color: this.getColor(
                feature.properties.stats[layer.radio],
                this.runtimeConfig['fpspoints'][layer.selectedPlatform][layer.radio]
              )
            }
          }
        },
        'll_index_-1': (feature) => ({
          color: feature.properties.loadTime[0] == data.maxValue
            ? "#0000ff"
            : this.getHeatMapColor(
              this.createValueForHeatMap(
                feature.properties.loadTime[0],
                this.runtimeConfig['ll_index_-1'][layer.selectedPlatform].loadTime
              ),
              false
            ),
          weight: 1
        }),
        'll_index_0': (feature) => ({
          color: feature.properties.loadTime[0] == data.maxValue
            ? "#0000ff"
            : this.getHeatMapColor(
              this.createValueForHeatMap(
                feature.properties.loadTime[0],
                this.runtimeConfig['ll_index_0'][layer.selectedPlatform].loadTime
              ),
              false
            ),
          weight: 1
        }),
        'runner': (feature) => {
          switch (true) {
            case feature.geometry.type === 'Polygon':
              return {
                color: '#0000ff',
                weight: 1
              }
            case feature.geometry.type === 'MultiLineString':
              return {
                color: this.getHeatMapColor(
                  this.createValueForHeatMap(
                    feature.properties.stats[layer.radio][0],
                    this.runtimeConfig['runner'][layer.selectedPlatform][layer.radio]
                  ),
                  false
                ),
                weight: 5
              }
            case feature.geometry.type === 'Point':
              return {
                color: feature.properties.color,
              }
            default: return undefined;
          }
        }
      }
    },
    pointToLayer (layer) {
      return {
        'custom': (feature, latlng) => {
          switch (true) {
            case feature.properties.type === 'point':
              return L.circleMarker(latlng)
            case feature.properties.type === 'circle':
              return L.featureGroup([
                L.circle(latlng, feature.properties.radius, {
                  stroke: true,
                  opacity: 0.7,
                  color: feature.properties.color,
                  weight: 1,
                  fillOpacity: 0.2,
                }),
                L.circleMarker(latlng, {
                  stroke: true,
                  radius: 1,
                  opacity: 1,
                  color: feature.properties.color,
                  fillOpacity: 1,
                }),
              ]);
            default: return undefined;
          }
        },
        'map_optimization': () => undefined,
        'llm': (feature, latlng) => {
          return L.circle(latlng, {
            stroke: true,
            radius: feature.geometry.radius,
            opacity: 1,
            fillOpacity: 0
          })
        },
        'llmpoints': (feature, latlng) => L.circleMarker(latlng),
        'discutilization': () => undefined,
        'fpspoints': (feature, latlng) => {
          if (feature.geometry.type === 'Point') {
            return L.circle(latlng, {
              stroke: true,
              radius: 0.5,
              opacity: 0.5,
              fillOpacity: 0
            })
          } else {
            return feature
          }
        },
        'll_index_-1':  () => undefined,
        'll_index_0':  () => undefined,
        'runner': (feature, latlng) => {
          if (feature.geometry.type !== 'Point') {
            return undefined
          } else {
            if (feature.properties.radius) {
              return L.featureGroup([
                L.circle(latlng, feature.properties.radius, {
                  stroke: true,
                  opacity: 0.7,
                  color: this.getHeatMapColor(
                    this.createValueForHeatMap(
                      feature.properties.stats[layer.radio][0],
                      this.runtimeConfig['runner'][layer.selectedPlatform][layer.radio]
                    ),
                    false
                  ),
                  weight: 1,
                  fillOpacity: 0.2,
                }),
                L.circleMarker(latlng, {
                  stroke: true,
                  radius: 1,
                  opacity: 1,
                  color: this.getHeatMapColor(
                    this.createValueForHeatMap(
                      feature.properties.stats[layer.radio][0],
                      this.runtimeConfig['runner'][layer.selectedPlatform][layer.radio]
                    ),
                    false
                  ),
                  fillOpacity: 1,
                }),
              ]);
            } else {
              return L.circleMarker(latlng, {
                stroke: false,
                radius: 3,
                fillOpacity: 1,
                fillColor: this.getHeatMapColor(
                  this.createValueForHeatMap(
                    feature.properties.stats[layer.radio][0],
                    this.runtimeConfig['runner'][layer.selectedPlatform][layer.radio]
                  ),
                  false
                )
              });
            }
          }
        }
      }
    },
    onEachRuntimeFeature(feature, layer) {
      layer.id = feature.properties.category + '_' + feature.properties.name;
      if (feature.properties.popupContent) {
        layer.bindPopup(feature.properties.popupContent);
      }
      if (feature.properties.tooltipContent) {
        layer.bindTooltip(feature.properties.tooltipContent,
          { permanent: true, direction:"center", className: "tooltip-inside-figure" }
        );
      }
      layer.on('add', () => {
        this.hideTooltips(layer)
      })
      layer.on('click', (event) => {
        const layer = event.target
        const index = this.runtimeLayers.findIndex(lr =>
          lr.category === layer.feature.properties.category
        )
        const {
          selectedBuild,
          selectedPrevBuild,
          selectedPlatform,
          selectedPrevPlatform
        } = this.runtimeLayers[index]

        return this.clickLayersFunctions[feature.properties.category](
          event,
          {
            selectedBuild,
            selectedPrevBuild,
            selectedPlatform,
            selectedPrevPlatform,
            mapName: this.map.options.currentMap
          }
        )
      })
      layer.on('remove', (event) => {
        delete this.map._layers[event.target.id];
        for (let key in this.map.customControls) {
          if (key.includes(feature.properties.category) && !key.includes('global')) {
            this.map.removeControl(this.map.customControls[key])
          }
        }
      })
    },
    createValueForHeatMap(currentValue, config) {
      console.log(config)
      return ((currentValue - config[0]) / (config[1] - config[0])) || 0
    },
    async changeMapId () {
      await this.loadCategories()
    },
    async changeMap () {
      await this.getSegments()
      this.uploadLayers()
    },
    async getSegments () {
      const level_name = this.map.options.currentMap || this.$route.query.map_name

      const { data } = await this.$axios.get(
        this.$store.getters.projectPath + '/segments',
        { params: { level_name } }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.segments = [
          ...Array(data && data.number_of_segments || 1)
        ].map((segment, index) => index + 1)
      }
    },
    uploadLayers () {
      this.runtimeLayers.forEach(category => {
        const currenGeoJSON = this.map.getLayerById(category.category)
        if (currenGeoJSON) {
          this.map.removeLayer(currenGeoJSON)
        }

        if (category.show) {
          this.toggleLayer(category)
        }
      })
    },
    filterLayers () {
      this.runtimeLayers.forEach(category => {
        if (category.show) {
          const currenGeoJSON = this.map.getLayerById(category.category)
          if (currenGeoJSON) {
            currenGeoJSON.eachLayer(layer => {
              if (layer.feature.properties.map_type == this.map.options.currentType) {
                this.map.addLayer(layer)
              } else {
                this.map.removeLayer(layer)
              }
            })
          }
        }
      })
    },
    updateRouterQuery (query) {
      const flag = Object.keys(query).reduce((all, key) => all && this.$route.query[key] !== query[key], true)

      if (flag) {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...query,
            tab: this.$route.query.tab,
            map_id: this.$route.query.map_id,
            map_name: this.$route.query.map_name,
            map_type: this.$route.query.map_type
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-wrapper {
    background-color: transparent;
    color: white;
  }

  .category {
    border: 1px solid rgba(0, 0, 0, 0.6);
    border-radius: 4px;
  }
</style>